import React from "react";
import { SVG } from "~components";
import cn from "classnames";
import * as styles from "./styles.module.scss";

/** ============================================================================
 * @component
 * Tags assist filter material by serving as a label or category for things such as articles.
 *
 * @typedef {(`filled` | `outline`)} variant
 *
 * @param  {string}  	text		 		Text
 * @param  {string}  	iconLeft 		Icon to render left of text
 * @param  {string}  	iconRight   Icon to render right of text
 * @param  {variant}  variant   	Presentation style (filled or outline)
 * @return {node}
 */

const Tag = ({ text, iconLeft, iconRight, variant = `filled` }) => (
  <div
    className={cn(styles.container, {
      [styles.filled]: variant === `filled`,
      [styles.outline]: variant === `outline`
    })}
  >
    <div className={styles.flex}>
      {iconLeft && (
        <SVG svg={iconLeft} className={cn(styles.icon, styles.left)} />
      )}
      {text && <span className="button-text">{text}</span>}
      {iconRight && (
        <SVG svg={iconRight} className={cn(styles.icon, styles.right)} />
      )}
    </div>
  </div>
);

export default Tag;
